/**
 * "My suppliers / All suppliers" scope toggle for purchasing list views.
 *
 * Rendered ONLY for users with allocated ERP buyer codes
 * (`user.buyer_codes` from auth). Backend list endpoints default to rows
 * whose PO line carries one of the user's codes; toggling to "All
 * suppliers" sends `all_suppliers=true` which lifts the scope for that
 * request. Users without codes never see this control and see everything.
 *
 * @param myOnly - current scope state (true = my suppliers only)
 * @param onChange - called with the new scope state
 * @param codes - the user's buyer codes (for the tooltip)
 */
import { Users, User } from 'lucide-react';

interface MySuppliersToggleProps {
  myOnly: boolean;
  onChange: (myOnly: boolean) => void;
  codes: string[];
}

export default function MySuppliersToggle({ myOnly, onChange, codes }: MySuppliersToggleProps) {
  if (!codes.length) return null;
  return (
    <div
      className="inline-flex rounded-lg border overflow-hidden text-sm"
      title={`Your buyer codes: ${codes.join(', ')}`}
    >
      <button
        onClick={() => onChange(true)}
        className={`px-3 py-1.5 flex items-center gap-1.5 ${myOnly ? 'bg-primary text-primary-foreground' : 'hover:bg-muted'}`}
      >
        <User className="h-3 w-3" />
        My suppliers
      </button>
      <button
        onClick={() => onChange(false)}
        className={`px-3 py-1.5 flex items-center gap-1.5 border-l ${!myOnly ? 'bg-primary text-primary-foreground' : 'hover:bg-muted'}`}
      >
        <Users className="h-3 w-3" />
        All suppliers
      </button>
    </div>
  );
}
